import { format } from 'date-fns';

export const getImageBySize = (url: string | object, w: number, h: number, fitIn = true) => {
  if (typeof url === 'string') {
    const urlPathnameSplitted = new URL(url).pathname.split('/');
    const sliceIndex = urlPathnameSplitted.findIndex((str) =>
      str.includes('builderpad-backend-infra')
    );
    const lastPart = urlPathnameSplitted.slice(sliceIndex + 1).join('/');
    return `${process.env.REACT_APP_CLOUD_FRONT}${fitIn ? '/fit-in' : ''}/${Math.ceil(
      w
    )}x${Math.ceil(h)}/${lastPart}`;
  }
};

export const getElementWidthById = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    return element.getBoundingClientRect().width;
  }

  return null;
};

export const dateTimeFormatter = (inputDate: string) => {
  const parsedDate = new Date(inputDate);
  const formattedDate = format(parsedDate, "MMM d, yyyy 'at' h:mmaaa");
  return formattedDate;
};

export const addDayToDate = (date: string | Date | undefined | null, day = 1) => {
  if (!date) return null;

  const originalDate = new Date(date);
  const newDate = new Date(originalDate);
  newDate.setDate(newDate.getDate() + day);

  return newDate;
};

/**
 * Nest/Joi validation often returns message as string | string[] | { message, property }[].
 * Always returns a string safe to render in toasts.
 */
export const getApiErrorMessage = (error: unknown, fallback = 'Something went wrong'): string => {
  const message = (error as { data?: { message?: unknown } })?.data?.message;

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  if (Array.isArray(message)) {
    const parts = message
      .map((item) => {
        if (typeof item === 'string') {
          return item;
        }

        if (item && typeof item === 'object' && 'message' in item) {
          const itemMessage = (item as { message?: unknown }).message;

          return typeof itemMessage === 'string' ? itemMessage : null;
        }

        return null;
      })
      .filter((part): part is string => !!part);

    if (parts.length) {
      return parts.join(' ');
    }
  }

  return fallback;
};
